import axios from "axios";

export default {
  all() {
    return new Promise(resolve => {
      resolve(axios.get('/api/claims'))
    })
  }
}
